import { DIALOG_ACTION } from "../actions/dialog";

const initialState = {
  isOpenDiaLog: false,
};

const dialogReduce = (state = initialState, action: { type: string }) => {
  switch (action.type) {
    case DIALOG_ACTION.OPEN:
      return { ...state, isOpenDiaLog: true };
    case DIALOG_ACTION.CLOSE:
      return { ...state, isOpenDiaLog: false };
    default:
      return state;
  }
};

export default dialogReduce;

export const getOpenDialog = (state: any) =>
  state?.dialogReduce?.isOpenDiaLog;
